<template>
  <div v-if="!error && detalle && isObject(detalle)">
    <b-skeleton-wrapper :loading="setLoader">
      <!-- Loader -->
      <template #loading>
        <b-row>
          <b-col
            lg="3"
            md="4"
            sm="12"
          >
            <div
              v-for="x in 7"
              :key="`loader-key-${x}`"
              class="mb-1"
            >
              <b-skeleton
                type="button"
                width="100%"
              />
            </div>

          </b-col>
          <b-col
            lg="9"
            md="8"
            sm="12"
          >
            <b-skeleton-img height="20rem" />
          </b-col>
        </b-row>
      </template>

      <section id="oferta-tabs">
        <b-tabs
          vertical
          content-class="col-12 col-md-8 col-lg-9"
          pills
          nav-wrapper-class="faq-navigation col-md-4 col-lg-3 col-12"
          nav-class="nav-left"
        >

          <!-- ACERCA DE -->
          <b-tab active>
            <template #title>
              <feather-icon
                icon="InfoIcon"
                size="18"
                class="mr-1"
              />
              <span class="font-weight-bold">Acerca de</span>
            </template>
            <acercaDe :detalle="detalle" />
          </b-tab>

          <!-- PLAN DE ESTUDIOS -->
          <b-tab>
            <template #title>
              <feather-icon
                icon="ClipboardIcon"
                size="18"
                class="mr-1"
              />
              <span class="font-weight-bold">Contenido</span>
            </template>

            <planEstudios />
          </b-tab>

          <!-- CALENDARIO -->
          <b-tab>
            <template #title>
              <feather-icon
                icon="CalendarIcon"
                size="18"
                class="mr-1"
              />
              <span class="font-weight-bold">Calendario</span>
            </template>

            <calendario />
          </b-tab>

          <!-- APORTACIONES -->
          <b-tab>
            <template #title>
              <feather-icon
                icon="DollarSignIcon"
                size="18"
                class="mr-1"
              />
              <span class="font-weight-bold">Aportaciones</span>
            </template>

            <aportaciones :plan="detalle.id ? detalle.id : null" />
          </b-tab>

          <!-- MODALIDADES DE ESTUDIO-->
          <b-tab v-if="detalle.otros_datos && detalle.otros_datos.modalidad">
            <template #title>
              <feather-icon
                icon="MonitorIcon"
                size="18"
                class="mr-1"
              />
              <span class="font-weight-bold">Modalidades de estudio</span>
            </template>

            <modalidades :periodo="detalle.periodo ? detalle.periodo : null" />
          </b-tab>

          <!-- Requisitos de inscripción -->
          <b-tab v-if="detalle.otros_datos && detalle.otros_datos.requiere_docs">
            <template #title>
              <feather-icon
                icon="FileTextIcon"
                size="18"
                class="mr-1"
              />
              <span class="font-weight-bold">Documentos requeridos </span>
            </template>
            <requisitos :plan="detalle.id ? detalle.id : null" />
          </b-tab>
          <!-- Requerimientos de Reconocimineto -->
          <b-tab v-if="detalle.requisitos_reconocimiento">
            <template #title>
              <feather-icon
                icon="AwardIcon"
                size="18"
                class="mr-1"
              />
              <span class="font-weight-bold">Requisitos para Reconocimiento</span>
            </template>
            <reconocimiento :reconocimiento="detalle.requisitos_reconocimiento" />
          </b-tab>
          <!-- Requerimientos del sistema -->
          <b-tab>
            <template #title>
              <feather-icon
                icon="CpuIcon"
                size="18"
                class="mr-1"
              />
              <span class="font-weight-bold">Requerimientos del sistema</span>
            </template>
            <sistema />
          </b-tab>

          <!-- PREGUNTAS FRECUENTES -->
          <b-tab>
            <template #title>
              <feather-icon
                icon="HelpCircleIcon"
                size="18"
                class="mr-1"
              />
              <span class="font-weight-bold">Preguntas frecuentes</span>
            </template>

            <preguntas />
          </b-tab>

        </b-tabs>
      </section>
    </b-skeleton-wrapper>
  </div>
</template>

<script>
import {
  BTabs, BTab, BRow, BCol,
  BSkeletonWrapper,
  BSkeletonImg,
  BSkeleton,
} from 'bootstrap-vue'
import { isObject, isEmptyObject } from '@core/utils/utils'
import aportaciones from '@/views/public/oferta-academica/components/detalle-oferta/tabs/aportaciones.vue'
import acercaDe from './tabs/acerca-de.vue'
import planEstudios from './tabs/plan-estudios.vue'
import modalidades from './tabs/modalidades.vue'
import requisitos from './tabs/requisitos.vue'
import reconocimiento from './tabs/reconocimiento.vue'
import sistema from './tabs/requerimientos-sistema.vue'
import preguntas from './tabs/preguntas.vue'
import calendario from './tabs/calendario.vue'

export default {
  components: {
    BTabs,
    BTab,
    BRow,
    BCol,
    BSkeletonWrapper,
    BSkeletonImg,
    BSkeleton,

    acercaDe,
    planEstudios,
    modalidades,
    reconocimiento,
    sistema,
    requisitos,
    preguntas,
    calendario,
    aportaciones,
  },
  props: {
    setLoader: {
      type: Boolean,
      default: false,
    },
    detalle: {
      type: Object,
      default: () => {},
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isObject,
      isEmptyObject,
      faqSearchQuery: '',
      faqData: {},
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-faq.scss';
</style>
